import { useExportCsvButtonModel } from './export-csv-button.model'
import type { IExportCsvButton } from './export-csv-button.types'
import { ExportCsvButtonView } from './export-csv-button.view'

export const ExportCsvButton = (props: IExportCsvButton) => {
  const exportCsvButtonModel = useExportCsvButtonModel(props)
  return <ExportCsvButtonView {...exportCsvButtonModel} />
}
